const RELATION_VERBS: Record<string, string> = {
  dependsOn: 'depende de',
  dependencyOf: 'depende de',
  providesApi: 'expõe API',
  apiProvidedBy: 'expõe API',
  consumesApi: 'consome API',
  apiConsumedBy: 'consome API',
  hasPart: 'contém',
  partOf: 'contém',
  ownerOf: 'é dono de',
  ownedBy: 'é dono de',
};

export function getRelationVerb(relations: string[]): string {
  if (!Array.isArray(relations) || relations.length === 0) {
    return '';
  }

  const known = relations.find(relation => RELATION_VERBS[relation]);
  if (known) {
    return RELATION_VERBS[known];
  }

  return relations[0];
}
